export const useSalesSelection = ({
    onAddItem
}) => {
    const handleSelectionChange = (list, id, itemType) => {
        const selected = list.find(item => item.id === id);
        if (selected) {
            // Para memberships: preserva o type original do plano (recurrent/fixed/pass)
            // e envia cartType para que handleAddItem saiba o tipo do item no carrinho.
            // Para produtos/serviços: sobrescreve type normalmente.
            if (itemType === 'membership') {
                onAddItem({ ...selected, cartType: itemType });
            } else {
                onAddItem({ ...selected, type: itemType });
            }
        }
    };

    return { handleSelectionChange };
};

